import { useMemo, useState } from "react";
import { X, Search, UserPlus, Check } from "lucide-react";

export default function AddConfirmedModal({ open, onClose, promoters, excludeIds, onAdd, title = "Adicionar confirmado" }) {
  const [q, setQ] = useState("");
  const [added, setAdded] = useState({});

  const list = useMemo(() => {
    const ex = excludeIds instanceof Set ? excludeIds : new Set(excludeIds || []);
    const term = q.trim().toLowerCase();
    return (promoters || [])
      .filter((p) => !ex.has(p.id))
      .filter((p) => !term || (p.name || "").toLowerCase().includes(term) || (p.phone || "").includes(term));
  }, [promoters, excludeIds, q]);

  if (!open) return null;

  const handleAdd = async (p) => {
    const ok = await onAdd(p.id);
    if (ok !== false) setAdded((a) => ({ ...a, [p.id]: true }));
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4" data-testid="add-confirmed-modal" onClick={onClose}>
      <div className="bg-white rounded-2xl shadow-xl w-full max-w-md max-h-[80vh] flex flex-col" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center justify-between px-5 py-4 border-b border-zinc-100">
          <div>
            <h3 className="text-base font-display font-bold text-zinc-950">{title}</h3>
            <p className="text-xs text-zinc-500 mt-0.5">Confirma diretamente — escolhes a seguir a mensagem a enviar.</p>
          </div>
          <button onClick={onClose} data-testid="add-confirmed-close" className="text-zinc-400 hover:text-zinc-900 p-1"><X className="w-5 h-5" /></button>
        </div>
        <div className="p-4 border-b border-zinc-100">
          <div className="relative">
            <Search className="w-4 h-4 text-zinc-400 absolute left-3 top-1/2 -translate-y-1/2" />
            <input
              autoFocus
              value={q}
              onChange={(e) => setQ(e.target.value)}
              placeholder="Pesquisar por nome ou telefone…"
              data-testid="add-confirmed-search"
              className="w-full pl-9 pr-3 py-2 rounded-lg border border-zinc-200 text-sm focus:outline-none focus:ring-2 focus:ring-zinc-950"
            />
          </div>
        </div>
        <div className="flex-1 overflow-y-auto divide-y divide-zinc-100">
          {list.length === 0 && <div className="px-4 py-8 text-center text-sm text-zinc-400">Sem promotores disponíveis.</div>}
          {list.map((p) => (
            <div key={p.id} data-testid={`add-confirmed-row-${p.id}`} className="flex items-center gap-3 px-4 py-2.5">
              <div className="min-w-0 flex-1">
                <div className="text-sm font-medium text-zinc-900 truncate">{p.name}</div>
                {p.phone && <div className="text-xs text-zinc-500">{p.phone}</div>}
              </div>
              {added[p.id] ? (
                <span className="inline-flex items-center gap-1 text-xs font-semibold text-emerald-700"><Check className="w-3.5 h-3.5" /> Adicionado</span>
              ) : (
                <button
                  onClick={() => handleAdd(p)}
                  data-testid={`add-confirmed-btn-${p.id}`}
                  className="inline-flex items-center gap-1 text-xs font-semibold px-2.5 py-1.5 rounded-lg bg-emerald-600 hover:bg-emerald-700 text-white"
                >
                  <UserPlus className="w-3.5 h-3.5" /> Adicionar
                </button>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
